
function SdQuotesCtrl($scope, TranslationService, StoreService) {
    var ctrl = this;
    ctrl.translation = TranslationService.getActiveTranslation();
    ctrl.dateFormat = StoreService.getDefaultDateFormat();

    //getColumnLayout();

    ctrl.$onInit = function () {
        console.log('$onInit');
        ctrl.generateColumns();

        ctrl.resetService = StoreService.resetCache;
        ctrl.loadColumns = StoreService.getQuotesColumns;
        ctrl.loadService = StoreService.searchQuotes;
    };

    ctrl.$onChanges = function (changes) {
        console.log('sd-quotes changes');
        console.log(changes);

        ctrl.prefs.parentFilter = ctrl.contactId;
    };

    ctrl.prefs = {
        name: 'StoreOrdersGrid',
        selContact: null,
        sortByCol: null,
        canAdd: false,
        canEdit: true,
        canDelete: false,
        doubleHeader: true,
    };

    ctrl.getIDClass = function (item) {
        return 'agp-color';
    };

    ctrl.statusClass = function (item) {
        return 'Status_Shipping Status_' + item;
    };
    

    ctrl.generateColumns = function() {
        ctrl.columns = [
            //{ name: 'ContractNumber', display: 'PO#', width: 5, filterOptions: [] },

            { name: 'CreateUserID', display: 'User', dataType: 'avatar', width: 0.1, filterOptions: [] },
            { name: 'TraderUserID', display: 'Trad', title:'Trader', dataType: 'avatar', width: 0.1, filterOptions: [] },
            { name: 'OrderID', display: 'Quote', width: 5, filterOptions: [] },
            { name: 'StatusID', display: 'Status Quotes', filterOptions: [], width: 5, translationPrefix: 'Status_', tdClass: ctrl.statusClass },
            {
                name: 'Containers', display: 'Status Shipping', width: 20,
                title: 'Containers for the quote',
                dataType: 'hasLinked',
                hasLinked: true,
                linkedCustomClass: ctrl.getSitPortalClass,
                openDetail: ctrl.openDetail,
            },
            {
                name: 'ContactName', display: 'Customer', width: 1, filterOptions: [], id: 'ContactID',
                //hasLinked: false,
                //linkedCustomClass: ctrl.getSitPortalClass,
                //openDetail: ctrl.openDetail,
            },            
            { name: 'IssueDate', display: 'Issue Date', dataType: 'date', format: ctrl.dateFormat, IsActive: true, width: 5 },

            //{ name: 'Linked', display: 'Containers', width: 15, dataType: 'array', fieldOnArray: 'OrderID' },            
        ];
    };


    ctrl.openDetail = function (item, ev) {
        ev.preventDefault();
        ev.stopPropagation();

        console.log('sd-quotes.openDetail ' + item.OrderID);
        var modalInstance = StoreService.openOrderDetailModal(item.OrderID);
        modalInstance.result.then(function (order) {
            if (order && order.StatusID) {
                item.StatusID = order.StatusID;
            }
        });
    };    

    ctrl.getSitPortalClass = function (sitPortal, statusID) {
        //console.log('getSitPortalClass ' + statusID);
        return StoreService.getSitPortalClass(sitPortal, statusID);
    };

    ctrl.prefs.customEdit = function (item) {
        console.log('openQuote');
        //console.log('Dashboard.openDetail');
        var modalInstance = StoreService.openOrderDetailModal(item.OrderID);
        modalInstance.result.then(function (order) {
            if (order && order.StatusID) {
                item.StatusID = order.StatusID;
            }
        });
    };

    ctrl.getSitPortalClass = function (sitPortal, statusID) {
        //console.log('getSitPortalClass ' + statusID);
        return StoreService.getSitPortalClass(sitPortal, statusID);
    };

    ctrl.doRefresh = function () {
        $scope.$broadcast('refreshServiceGrid');
        //$scope.loadTotal();
    };

    ctrl.searchMode = function () {
        console.log('searchMode');
        $scope.$broadcast('inputSearch', ctrl.filterString);
    };
}

SdQuotesCtrl.$inject = ['$scope', 'TranslationService', 'StoreService'];

seedWebApp.component('sdQuotes', {
    controller: SdQuotesCtrl,
    bindings: {
        contactId: '<',
        quotesCount: '=',
        overflowSize: '<',
    },
    templateUrl: '/SPA/Quotes/sd-quotes.html' + seedWebApp.buildVersion
});